"use client";
import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { useDict } from "@/components/providers/LocaleProvider";
import { TransitionLink } from "@/components/shared/TransitionLink";

interface BookMeetingLinkProps {
    className?: string;
}

const BookMeetingLink = ({ className }: BookMeetingLinkProps) => {
  const t = useDict();
  return (
    <TransitionLink
      href={"/book-a-meeting"}
      className={` w-full cursor-pointer active:scale-95 hover:bg-primary/70 duration-200 gap-2 group bg-primary/80 text-white  py-2 rounded-lg flex justify-center items-center ${className}`}
    >
      <p>{t.nav.bookMeeting}</p>
      <FaCalendarAlt size={17} className=" duration-200" />
    </TransitionLink>
  );
};

export default BookMeetingLink;
